<div *ngIf="hasErrors" class="alert alert-danger">
  <p><strong>{{title | translate}}</strong></p>
  <ul>
    <li *ngFor="let message of errorMessages">{{message | translate}}</li>
  </ul>
</div>
